import React, { useState } from 'react'
import CryptoJS from 'crypto-js'
import { Pagination } from '@mui/material'
import Spiner from '../components/modals/Spiner'
import { useCart } from '../functions/context/CartProvider'
import t from '../translations/i18n'
import ReactModal from 'react-modal'
import { useSnackbar } from 'notistack'
import userLogic from '../functions/logic/userLogic'
import { Link } from 'react-router-dom'
import '../scss/products.scss'

export default function ProductsGrid({
  data = [{}],
  totalPages,
  paginate,
  currentPage = 1
}) {
  const [load, setLoad] = useState(false)
  const { addToCart } = useCart()
  const token = localStorage.getItem('authToken')
  const isLoggedIn = !!token
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [currentProduct, setCurrentProduct] = useState(null)
  const [quantity, setQuantity] = useState(1)
  const { enqueueSnackbar } = useSnackbar()
  const [activeProduct, setActiveProduct] = useState(null)
  // Detecta si está en local o producción
  const uploadsUrl =
    process.env.NODE_ENV === 'development'
      ? process.env.REACT_APP_UPLOADS_URL_IMG_LOCAL
      : process.env.REACT_APP_UPLOADS_URL_IMG

  const closeModal = () => {
    setIsModalOpen(false)
    setCurrentProduct(null)
    setQuantity(1)
  }

  const handleAddToCart = async (item) => {
    setLoad(true)

    await new Promise((resolve) => setTimeout(resolve, 800))

    try {
      const iva = item.iva_precio * quantity
      const total = item.prod_precio * quantity + iva

      const updatedCartItem = {
        id: item.id,
        empresa_id: item.empresa_id,
        name: item.prod_name,
        price: item.prod_precio,
        iva,
        total,
        tarifa: item.tarifa,
        valor_descuento: item.valor_descuento,
        tarifa_descuento: item.tarifa_descuento,
        precio_descuento: item.precio_descuento,
        total_descuento: item.total_descuento,
        iva_descuento: item.iva_descuento,
        quantity,
        imageUrl: `${uploadsUrl}${item.url_imagen}`
      }

      const updatedCartItems = [updatedCartItem]

      if (isLoggedIn) {
        const response = await userLogic.saveViewCartLogic(updatedCartItems)

        enqueueSnackbar(response.data.message, {
          variant: response.variant,
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right'
          }
        })

        if (response.success) {
          addToCart(updatedCartItem)
        }
      } else {
        addToCart(updatedCartItem)
      }
    } catch (error) {
      console.error(error)

      enqueueSnackbar('No se pudo agregar el producto al carrito.', {
        variant: 'error',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      })
    } finally {
      setLoad(false)
    }
  }

  const handleQuickViewClick = (e, product) => {
    e.preventDefault()
    openModal(product)
  }

  const openModal = (product) => {
    setCurrentProduct(product)
    setIsModalOpen(true)
  }

  const encryptId = (id) => {
    const encrypted = CryptoJS.AES.encrypt(
      id.toString(),
      'secret-key'
    ).toString()

    return encrypted.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
  }

  const handleQuantityChange = (e) => {
    setQuantity(e.target.value)
  }

  return (
    <>
      <Spiner opt={load} />

      <div className="products">
        <div className="products-grid">
          {data.length > 0 ? (
            data.map((product, index) => {
              const isDiscountAvailable =
                product.valor_descuento &&
                product.tarifa_descuento &&
                product.precio_descuento &&
                Number(product.valor_descuento) > 0 &&
                Number(product.tarifa_descuento) > 0 &&
                Number(product.precio_descuento) > 0

              return (
                <div key={`${product.id}-${index}`} className="product-card">
                  <div className="product">
                    <figure className="product-media-grid">
                      {isDiscountAvailable && (
                        <span className="product-label">Oferta</span>
                      )}

                      <Link
                        to={`${global.PRODUCTDETAIL}/${encryptId(product.id)}`}
                      >
                        <img
                          src={`${uploadsUrl}${product.url_imagen}`}
                          alt={product.prod_name}
                          className="product-image"
                        />
                      </Link>

                      <div className="product-action-vertical">
                        <button
                          className="btn-product-icon btn-quickview"
                          title="Quick view"
                          onClick={(e) => handleQuickViewClick(e, product)}
                        >
                          <span>{t('products.quick_view')}</span>
                        </button>
                      </div>

                      <div className="product-action">
                        <button
                          onClick={(e) => {
                            e.preventDefault()
                            handleAddToCart(product)
                          }}
                          className="easybuy-add-cart"
                          title={t('products.add_to_cart')}
                        >
                          <i className="la la-shopping-cart"></i>

                          <span>{t('products.add_to_cart')}</span>
                        </button>
                      </div>
                    </figure>

                    <div className="product-body">
                      <div className="product-cat">
                        <span>{product.cat_name}</span>
                      </div>

                      <h3 className="product-title">
                        <Link
                          to={`${global.PRODUCTDETAIL}/${encryptId(
                            product.id
                          )}`}
                        >
                          {product.prod_name}
                        </Link>
                      </h3>

                      <div className="product-title">
                        {isDiscountAvailable ? (
                          <>
                            <span className="new-price">
                              ${product.precio_descuento}
                            </span>
                            Antes{' '}
                            <span className="old-price">
                              ${product.prod_precio}
                            </span>
                          </>
                        ) : (
                          <span>${product.prod_precio}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )
            })
          ) : (
            <p className="text-center">No hay productos disponibles.</p>
          )}
        </div>
      </div>

      <Pagination
        count={totalPages || 1}
        color="primary"
        siblingCount={1}
        boundaryCount={1}
        variant="outlined"
        shape="rounded"
        size="large"
        page={currentPage}
        onChange={paginate}
        className="pagination justify-content-center"
      />

      <ReactModal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Quick View Modal"
        className="quick-view-modal"
        overlayClassName="quick-view-overlay"
      >
        <button className="close-modal" onClick={closeModal}>
          X
        </button>

        {currentProduct && (
          <div className="container quickView-container">
            <div className="quickView-content">
              <div className="row">
                <div className="col-lg-7 col-md-6">
                  <div className="product-left-modal">
                    <img
                      src={`${uploadsUrl}${currentProduct.url_imagen}`}
                      alt={currentProduct.prod_name}
                      className="product-image-products"
                    />
                  </div>
                </div>

                <div className="col-lg-5 col-md-6">
                  <h2 className="product-title-modal">
                    {currentProduct.prod_name}
                  </h2>

                  <h3 className="product-price-modal">
                    ${currentProduct.prod_precio}
                  </h3>

                  <div className="product-txt-modal">
                    {currentProduct.prod_desc || 'No description available.'}
                  </div>

                  <label htmlFor="qty">{t('products.Qty')}</label>

                  <div className="product-details-quantity">
                    <input
                      type="number"
                      id="qty"
                      className="form-control qty-input"
                      value={quantity}
                      min="1"
                      max="10"
                      step="1"
                      onChange={handleQuantityChange}
                      required
                    />
                  </div>

                  <div className="product-details-action">
                    <button
                      onClick={(e) => {
                        e.preventDefault()
                        handleAddToCart(currentProduct)
                      }}
                      className="easybuy-add-cart"
                    >
                      <i className="la la-shopping-cart"></i>

                      <span>{t('products.add_to_cart')}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </ReactModal>
    </>
  )
}
